import { useMemo } from 'react';
import sortBySubscriptionId from '../helpers/sort-by-subscription-id';
import splitFeaturesByGroups from '../helpers/split-features-by-groups';

const useSortedData = ({ computedPlans, compactPlans, planFeatures, areEcommercePlans, isB2C }) => {
  const sortedPlanFeatures = useMemo(
    () =>
      planFeatures.map((feature) => ({
        ...feature,
        availabilities: sortBySubscriptionId(feature.availabilities).reverse(),
      })),

    [planFeatures]
  );

  return useMemo(
    () => ({
      computedPlans: sortBySubscriptionId([...computedPlans]).reverse(),
      compactPlans: sortBySubscriptionId([...compactPlans]).reverse(),
      planFeatures: areEcommercePlans
        ? sortedPlanFeatures
        : splitFeaturesByGroups(sortedPlanFeatures, isB2C),
    }),
    [computedPlans, compactPlans, sortedPlanFeatures, areEcommercePlans, isB2C]
  );
};

export default useSortedData;
